<template>
  <div class="pc3-app-layout">
    <header class=" fx__header pc3-app-header" 
      :style="thema=='blue'?'box-shadow: 0px 3px 6px rgba(16, 40, 87, 0.19)':`background: url(${$store.state.core.top.topImg}) 100% 100%;`"
    >
      <appHeader />
    </header>
    <div class="pc3-app-sub-layout">
      <sideBar />
      <div class="pc3-app-content" :style="{'padding-left': this.$store.state.core.maxMenuWidthPc3}">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </div>

  </div>
</template>
<script>
import sideBar from "./sideBar"; 
import appHeader from "./header";

export default {
  components: { sideBar, appHeader },
  data() {
    return {
      width:'280px'
    };
  },
   computed:{
    thema() {
      return this.$store.state.core.thema;
    },
  },
  mounted() {
    let _this = this
    // fd.dispose()
  },
};
</script>




<style lang="scss" scoped>
/* body {
  overflow: hidden;
} */

.pc3-app-layout {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: calc(100vh);
  position: relative;

  .pc3-app-header {
    
    /* height: 50px; */
    flex: 70px 0 0;
    z-index: 1000;
    // z-index: 99;
  }

  .pc3-app-sub-layout {
    flex: 1;
    height: calc(100% - 70px);
    display: flex;
  }

  .pc3-app-sider {
    flex-shrink: 0;
    overflow: auto;
  }

  .pc3-app-content {
    /* padding: 10px; */
    overflow: hidden;
    flex-grow: 1;
    /* height: calc(100%); */
    padding-left: 260px;
    /* 200px应该是动态传参的，像sidebar一样 */
  }
}
</style>